import React from "react";
import { Form } from "sc/ui/components/Form";
import formWithMessages from "sc/ui/components/hoc/formWithMessages";

export const ERROR_EMPTY_NAME = "empty_name";
export const ERROR_EMPTY_INTERNAL_ID = "empty_internal_id";
export const ERROR_BAD_FORMAT_INTERNAL_ID = "internal_id_bad_format";
export const ERROR_NAME_OR_ID_ALREADY_EXISTS = "name_already_in_use";
export const ERROR_SOMETHING_WENT_WRONG = "something_went_wrong";

export default formWithMessages(props => {
  const { partner, onSave, disabled, messagesProps } = props;
  return (
    <Form
      formProps={{
        id: `partner-form`,
        horizontal: true,
      }}
      onSubmit={onSave}
      {...messagesProps}
      fields={{
        name: {
          uiProps: {
            type: "text",
            placeholder: "Partner name",
            autoFocus: true,
            maxLength: 100,
          },
          position: 1,
          initialValue: partner.name,
          label: "Partner name ",
        },
        internalId: {
          uiProps: {
            type: "text",
            placeholder: "Internal Id",
            maxLength: 11,
          },
          position: 2,
          initialValue: partner.internalId,
          label: "Internal Id ",
          onChange: newInternalId => newInternalId.replace(/\D/g, ""),
        },
        enabled: {
          uiProps: {
            type: "checkbox",
          },
          position: 3,
          initialValue: partner.enabled,
          label: "Enabled ",
        },
      }}
      validation={formData => {
        if (!formData.name) return ERROR_EMPTY_NAME;
        if (!formData.internalId) return ERROR_EMPTY_INTERNAL_ID;
        return undefined;
      }}
      submitButtonProps={{
        disabled,
        children: "Save",
        bsStyle: "primary",
      }}
      errorMessages={{
        [ERROR_EMPTY_NAME]: "Partner name can't be empty",
        [ERROR_EMPTY_INTERNAL_ID]: "Internal id can't be empty",
        [ERROR_NAME_OR_ID_ALREADY_EXISTS]:
          "Either the partner name or internal id is already in use!",
        [ERROR_SOMETHING_WENT_WRONG]: "Something went wrong please try again!",
        [ERROR_BAD_FORMAT_INTERNAL_ID]:
          "Internal Id must be a number (maximum 11 digits)",
      }}
    />
  );
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/components/forms/Partner.js